import { useMemo } from 'react';
import { Shippings } from '@app/pages/checkout-app/types';
import { Checkout } from '../../../models/Checkout';

export const useAllShippingMethods = (checkoutGroups: Checkout[]): Shippings[] => {
  return useMemo(() => {
    return checkoutGroups.flatMap((checkout) => checkout.checkoutShippings || []).filter((m) => !m.fallbackMethod);
  }, [checkoutGroups]);
};
